import AuthService from "vamos/cockpit/base/services/type/AuthService";
import DebugSettings from "vamos/cockpit/config/DebugSettings";
import JSONModel from "sap/ui/model/json/JSONModel";

export default class DebugHandler {

    public static handle(): void {
        const debugSettings = DebugHandler.loadDebugSettings();

        if (debugSettings && debugSettings.login?.content?.apiToken) {
            AuthService.setToken(debugSettings.login?.content?.apiToken);
        }
    }

    private static loadDebugSettings(): DebugSettings | null {
        try {
            const debugModel = new JSONModel();

            debugModel.loadData("../debug.json", "", false);
            return debugModel.getData();
        } catch (e) {
            console.debug(e);
        }
    }

}